export function padZero(str, len?) {
  len = len || 2;
  const zeros = new Array(len).join("0");
  return (zeros + str).slice(-len);
}

// https://stackoverflow.com/questions/35969656/how-can-i-generate-the-opposite-color-according-to-current-color
export function invertColor(hex, bw) {
  if (hex.indexOf("#") === 0) {
    hex = hex.slice(1);
  }
  // convert 3-digit hex to 6-digits.
  if (hex.length === 3) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }
  if (hex.length !== 6) {
    return hex;
    // throw new Error('Invalid HEX color.');
  }
  const red = parseInt(hex.slice(0, 2), 16);
  const green = parseInt(hex.slice(2, 4), 16);
  const black = parseInt(hex.slice(4, 6), 16);
  if (bw) {
    // http://stackoverflow.com/a/3943023/112731
    return red * 0.299 + green * 0.587 + black * 0.114 > 186
      ? "#000000"
      : "#FFFFFF";
  }
  // invert color components
  const sRed = (255 - red).toString(16);
  const sGreen = (255 - green).toString(16);
  const sBlue = (255 - black).toString(16);
  // pad each with zeros and return
  return "#" + padZero(sRed) + padZero(sGreen) + padZero(sBlue);
}
